"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewOrgPartner extends new_item_1.default {
    constructor(newOrgPartner) {
        super();
        this.orgName = newOrgPartner.orgName;
        this.orgToName = newOrgPartner.orgToName;
        this.name = newOrgPartner.name;
        this.orgFromName = newOrgPartner.orgFromName;
        this.orgId = newOrgPartner.orgId;
        this.orgToId = newOrgPartner.orgToId;
        this.dataTypes = newOrgPartner.dataTypes;
        this.deviceList = newOrgPartner.deviceList;
        this.orgFromId = newOrgPartner.orgFromId;
        this.permType = newOrgPartner.permType;
        this.orgEmailAddress = newOrgPartner.orgEmailAddress;
        this.sites = newOrgPartner.sites;
        this.partnerDirection = newOrgPartner.partnerDirection;
        this.whiteLabel = newOrgPartner.whiteLabel;
        this.inheritWhiteLabelFrom = newOrgPartner.inheritWhiteLabelFrom;
        this.whiteLabelTheme = newOrgPartner.whiteLabelTheme;
        this.whiteLabelCustomTheme = newOrgPartner.whiteLabelCustomTheme;
        this.logoImage = newOrgPartner.logoImage;
        this.orgFromLogoImage = newOrgPartner.orgFromLogoImage;
        this.logoImageThumbnail = newOrgPartner.logoImageThumbnail;
        this.squareLogoImage = newOrgPartner.squareLogoImage;
        this.orgFromSquareLogoImage = newOrgPartner.orgFromSquareLogoImage;
        this.squareLogoImageThumbnail = newOrgPartner.squareLogoImageThumbnail;
        this.orgFromWhiteLabel = newOrgPartner.orgFromWhiteLabel;
        this.orgFromInheritWhiteLabelFrom = newOrgPartner.orgFromInheritWhiteLabelFrom;
        this.orgFromWhiteLabelTheme = newOrgPartner.orgFromWhiteLabelTheme;
        this.orgFromWhiteLabelCustomTheme = newOrgPartner.orgFromWhiteLabelCustomTheme;
        this.orgFromContactEmail = newOrgPartner.orgFromContactEmail;
        this.contactEmail = newOrgPartner.contactEmail;
        this.issues = newOrgPartner.issues;
        this.appliances = newOrgPartner.appliances;
        this.lowBatteryAssets = newOrgPartner.lowBatteryAssets;
        this.lowSignalAssets = newOrgPartner.lowSignalAssets;
        this.assetsWithIssues = newOrgPartner.assetsWithIssues;
        this.faultyAssets = newOrgPartner.faultyAssets;
        this.intermittentAssets = newOrgPartner.intermittentAssets;
        this.anomalousAssets = newOrgPartner.anomalousAssets;
        this.widgetBoardId = newOrgPartner.widgetBoardId;
    }
}
exports.default = NewOrgPartner;
//# sourceMappingURL=new-orgPartner.js.map